import { Coolwhip } from '@circlefin/components'
import { Footer, HeaderPublic } from '@containers/layout'
import { Main } from '@shared/components/layout'
import { BaseLayout } from '@shared/layout/core'

import { LoadingGuard } from '../../containers'
import { AccountSetupProvider } from '../../hooks/account-setup/provider'

import type { AppLayoutType } from '@shared/layout/core'

export const AccountSetupLayout: AppLayoutType = ({ children }) => {
  return (
    <AccountSetupProvider>
      <BaseLayout className="auto-rows-min grid-rows-[min-content_auto_min-content] text-neutral-subtle">
        <div>
          <HeaderPublic>
            <HeaderPublic.Logo align="center" variant="mobile-full" />
            <HeaderPublic.SignIn className="hidden md:block" />
            <HeaderPublic.LogOut />
          </HeaderPublic>
          <div className="h-0.5 w-full bg-black-75" />
        </div>
        <Coolwhip
          className="fixed bottom-0 h-screen w-full translate-y-56 opacity-0 md:opacity-100"
          variant="fade-top/green-blue-violet"
        />
        <Main className="relative flex px-6 pb-12 pt-8 md:px-13 md:pt-9">
          <LoadingGuard>{children}</LoadingGuard>
        </Main>
        <Footer />
      </BaseLayout>
    </AccountSetupProvider>
  )
}
